import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, AfterContentChecked } from '@angular/core';

import { Router } from '@angular/router';

import Utils from '../shared/utility';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';

import * as shape from 'd3-shape';
import 'rxjs/operator/map';
import 'rxjs/operator/filter';
import 'rxjs/operator/pluck';

@Component({
  selector: 'app-medicare-means-testing',
  templateUrl: './medicare-means-testing.component.html',
  styleUrls: ['./medicare-means-testing.component.css']
})
export class MedicareMeansTestingComponent implements OnInit {
  public mmtData: any;
  public error: string;
  public client: any;
  public areaChartData = [];
  public chartDataLoaded: boolean;

  @ViewChild('totalPremiumsEl') totalPremiumsEl: ElementRef;
  @ViewChild('totalSurchargeSavingsEl') totalSurchargeSavingsEl: ElementRef;
  @ViewChild('totalSurchargesEl') totalSurchargesEl: ElementRef;
  @ViewChild('totalMedicareEl') totalMedicareEl: ElementRef;

  public magiInfo: string = "Reducing your projected MAGI (Modified Adjusted Gross Income) may lower or eliminate future surcharges. Allocating future income towards product that does not impact MAGI may result in significant savings.";
  public medicarePremiumsInfo: string = "Projected lifetime Medicare Part B and D premiums.";
  public surchargesInfo: string = "Projected additional lifetime costs associated with Medicare Part B and D (premiums excluded) applied due to income, via Medicare means testing.";
  public totalMedicareInfo: string = "Projected Medicare Part B and D premiums plus all applicable surcharges.";
  public surchargeSavingsInfo: string = 'Projected surcharge costs no longer paid due to decreased "MAGI %" user input above.';

  public ssStartAgeVal: number = 65;
  public ssMonthlyBenefit: number = 1250;
  public inflationRateVal: number = 3;
  public magiVal: number = 100;
  public partnerActive: boolean = false;
  public ssSpouseMonthlyBenefit: number = 1250;
  public ssSpouseStartAgeVal: number = 65;

  public totalSurcharge: string = '';
  public totalPremiums: string = '';
  public totalMedicare: string = '';

  public bracketData;

  curves = {
    Basis: shape.curveBasis,
    'Basis Closed': shape.curveBasisClosed,
    Bundle: shape.curveBundle.beta(1),
    Cardinal: shape.curveCardinal,
    'Cardinal Closed': shape.curveCardinalClosed,
    'Catmull Rom': shape.curveCatmullRom,
    'Catmull Rom Closed': shape.curveCatmullRomClosed,
    Linear: shape.curveLinear,
    'Linear Closed': shape.curveLinearClosed,
    'Monotone X': shape.curveMonotoneX,
    'Monotone Y': shape.curveMonotoneY,
    Natural: shape.curveNatural,
    Step: shape.curveStep,
    'Step After': shape.curveStepAfter,
    'Step Before': shape.curveStepBefore,
    default: shape.curveLinear
  };

  // line interpolation
  curveType: string = 'Step';
  curve: any = this.curves[this.curveType];
  interpolationTypes = [
    'Basis', 'Bundle', 'Cardinal', 'Catmull Rom', 'Linear', 'Monotone X',
    'Monotone Y', 'Natural', 'Step', 'Step After', 'Step Before'
  ];

  closedCurveType: string = 'Linear Closed';
  closedCurve: any = this.curves[this.closedCurveType];
  closedInterpolationTypes = [
    'Basis Closed', 'Cardinal Closed', 'Catmull Rom Closed', 'Linear Closed'
  ];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  // xAxisLabel = 'Country';
  showYAxisLabel = true;
  // yAxisLabel = 'Population';

  // colorScheme = {
  //   domain: ['#A10A28', '#D3342D', '#EF6D49', '#FAAD67', '#FDDE90', '#DBED91', '#A9D770', '#6CBA67', '#2C9653', '#146738']
  // };

  colorScheme = {
    domain: [],
    // domain: ['#D3DFF2', '#a8b2c1', '#F6CC9E', '#c4a37e', '#F7E5CD','#c5b7a4', '#e2e3e4', '#b4b5b6', '#f99a9a', '#c77b7b']
  };

  // string[] colors = new string[6] { "#AFB5D3", "#D3DFF2", "#F6CC9E", "#F7E5CD", "#f99a9a", "#E2E3E4" };



  // line, area
  autoScale = true;

  constructor(private globalService: GlobalService, private modalService: ModalService, private snackBarService: SnackBarService, private router: Router, private loadingService: LoadingService, private elementRef: ElementRef) {
    modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.getClient();
        this.magiVal = 100;
        this.animateValue(this.totalSurchargeSavingsEl, 0, this.roundAndFormat(0, 0));
        // console.log('reset to defaults');
      }
      // console.log(modal.modalName);
    });
  }

  ngOnInit() {
    this.bracketData = this.setBracketData();
    // console.log('init')

    this.getClient();
    // this.magiVal = 100;
    // this.animateValue(this.totalSurchargeSavingsEl, 0, this.roundAndFormat(0, 0));
  }

  ngAfterViewInit() {
    //var d1 = this.elementRef.nativeElement.querySelector('.tooltip-area');
    //d1.insertAdjacentHTML('beforeend', '<div class="seven">seven</div>');
  }

  onSelect(event) {
    // console.log(event);
  }

  getMMTData(client: any, mmtInputs: any) {

    var user = {
      UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
      CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
      ClientID: localStorage.getItem('selectedClient')
    }


    this.globalService.getMMTData(client, mmtInputs, user)
      .subscribe(
      mmtData => {
        this.mmtData = mmtData;
        this.createAreaChartData(mmtData);
        this.calculateTotals(mmtData);
      },
      error => this.error = <any>error);
  }

  public startingSurchageAmount = null;

  public ssAmount = 0;

  calculateTotals(data: any) {
    var ts = 0, tp = 0, tm = 0, tss = 0;

    for (var ageRange in data.MagiAdjustedAgeRangeCosts) {
      tp += data.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount;
      ts += (data.MagiAdjustedAgeRangeCosts[ageRange].Amount - data.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount);
      tm += data.MagiAdjustedAgeRangeCosts[ageRange].Amount;
    }

    // console.log(ts);


    if (this.startingSurchageAmount === null) {
      this.startingSurchageAmount = ts;
      // tss = this.startingSurchageAmount;
      tss = 0;
      // console.log('a', this.startingSurchageAmount);
    } else {
      // console.log('b', this.startingSurchageAmount);
      tss = this.startingSurchageAmount - ts;
    }



    // console.log('b', this.startingSurchageAmount);
    // tss = this.startingSurchageAmount - ts;

    // this.totalPremiums = this.roundAndFormat(tp);
    // this.totalSurcharge = this.roundAndFormat(ts);
    // this.totalMedicare = this.roundAndFormat(tm);

    this.ssAmount = tss;


    // console.log(tss);
    this.animateValue(this.totalPremiumsEl, 0, this.roundAndFormat(tp, 0));
    this.animateValue(this.totalSurchargesEl, 0, this.roundAndFormat(ts, 0));
    this.animateValue(this.totalMedicareEl, 0, this.roundAndFormat(tm, 0));
    this.animateValue(this.totalSurchargeSavingsEl, 0, this.roundAndFormat(tss, 0));
  }

  animateValue(el, start, formattedNumber): void {
    var end = parseFloat(formattedNumber.shortValue);
    var range = end - start;
    var current = end / 1.2;
    var increment = start < 0 ? -1 : 1;
    var stepTime = Math.abs(10);

    if (formattedNumber.shortValue > 0) {
      el.nativeElement.innerHTML = `$${end.toFixed(1)}${formattedNumber.suffix || ''}`;

      // var timer = setInterval(function () {
      //   if (Math.abs(current - end) < 5) {
      //     increment = start < 0 ? -0.1 : 0.1;
      //   }

      //   current += increment;
      //   el.nativeElement.innerHTML = `$${current.toFixed(1)}${formattedNumber.suffix}`;

      //   if (current.toFixed(1) == end.toFixed(1)) {
      //     clearInterval(timer);
      //   }
      // }, stepTime);
    } else {
      el.nativeElement.innerHTML = `$0`;
    }
  }

  roundAndFormat(num, fixed) {
    if (num === null) { return null; }
    if (num === 0) { return '0'; }
    fixed = (!fixed || fixed < 0) ? 0 : fixed;
    var b = (num).toPrecision(2).split("e"),
      k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
      c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
      d = c < 0 ? c : Math.abs(c),
      e = d + ['', 'K', 'M', 'B', 'T'][k];

    return { shortValue: e.split(/[A-z]/)[0], suffix: e.substring(e.length - 1, e.length) };
  }

  getClient() {
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
      client => {
        // console.log('CLIENT INFO:', client);
        this.client = client;
        this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
        this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);

        if (this.client.clientProfile.Spouses.length > 1) {
          this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
        }

        if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married')
          this.partnerActive = true;
        else
          this.partnerActive = false;

        this.ssMonthlyBenefit = this.client.clientProfile.PIA;
        this.ssStartAgeVal = 65;
        this.inflationRateVal = 3;


        if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
          this.ssSpouseMonthlyBenefit = this.client.clientProfile.Spouses[0].pia;
          this.ssSpouseStartAgeVal = 65;
        }

        // console.log(this.client);

        var tempReportVals = {
          // InflationRate: this.inflationRateVal / 100,
          InflationRate: parseFloat((this.inflationRateVal / 100).toString()),
          MagiIncomePercent: this.magiVal,
          IncludePartner: this.partnerActive,
          SocialSecurityRetirementAge: this.ssStartAgeVal,
          SSMonthlyBenefit: this.client.clientProfile.PIA,
          PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "") || 0 : this.client.clientProfile.Spouses[0] ? this.client.clientProfile.Spouses[0].pia || 0 : 0,
          PartnerSocialSecurityAge: this.ssSpouseStartAgeVal
        }

        // console.log(tempReportVals);

        this.getMMTData(client, tempReportVals);
      },
      error => this.error = <any>error);
  }

  handleSaveAndDownloadReport() {
    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: 2,
    }

    // var ReportMMT = {
    //   SSClaimAge: this.ssStartAge,
    //   SSMonthlyBenefit: this.ssMonthlyBenefit,
    //   MAGI: this.magi,
    // }

    var ReportMMT = {
      ClientSSMonthlyBenefit: this.client.clientProfile.PIA,
      InflationRate: this.inflationRateVal,
      MagiIncomePercent: this.magiVal,
      IncludePartner: this.partnerActive,
      SurvivorIncomeReductionRate: 44,
      RetirementIncomeReduction: '',
      IncomeReductionAge: '',
      IncomeReductionInflationRate: '',
      ClientSocialSecurityAge: this.ssStartAgeVal,
      ClientPensionSurvivorBenefitPercent: 0,
      ClientLifeExpectancy: this.mmtData.Client.LifeExpectancy,
      PartnerSocialSecurityAge: this.ssSpouseStartAgeVal,
      PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "") || 0 : this.client.clientProfile.Spouses[0] ? this.client.clientProfile.Spouses[0].pia || 0 : 0,
      PartnerPensionSurvivorBenefitPercent: 0,
      PartnerLifeExpectancy: this.mmtData.Partner ? this.mmtData.Partner.LifeExpectancy : 0,
      ClientCurrentAge: this.mmtData.Client.CurrentAge,
      ClientCurrentIncome: this.client.clientProfile.CurrentIncome,
      ClientGender: this.mmtData.Client.Gender,
      ClientHealthRating: this.mmtData.Client.HealthRating,
      ClientPensionAmount: this.mmtData.Client.PensionAmount,
      ClientRetirementAge: this.mmtData.Client.RetirementAge,
      FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
      FrmName1: this.mmtData.Partner ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
      PartnerCurrentAge: this.mmtData.Partner ? this.mmtData.Partner.CurrentAge : 0,
      PartnerCurrentIncome: this.mmtData.Partner ? this.mmtData.Partner.CurrentIncome : 0,
      PartnerGender: this.mmtData.Partner ? this.mmtData.Partner.Gender : 0,
      PartnerHealthRating: this.mmtData.Partner ? this.mmtData.Partner.HealthRating : 0,
      PartnerPensionAmount: this.mmtData.Partner ? this.mmtData.Partner.PensionAmount : 0,
      PartnerRetirementAge: this.mmtData.Partner ? this.mmtData.Partner.RetirementAge : 0,
      ReplacementRate: this.client.clientProfile.IRR,
      State: this.client.clientProfile.RetirementState,
      SurchargeSavings: this.ssAmount,


      // InflationRate: this.inflationRate / 100,
      // MagiIncomePercent: this.magi,
      // IncludePartner: this.partnerActive,
      // SocialSecurityRetirementAge: this.ssStartAge,
      // SSMonthlyBenefit: this.ssMonthlyBenefit,
      // // LifeExpectancy: this.client.clientProfile.lifeExpectancy,
      // PartnerSocialSecurityAge: this.ssSpouseStartAge,
      // PartnerSSMonthlyBenefit: this.ssSpouseMonthlyBenefit,
      // PartnerLifeExpectancy: this.client.clientProfile.Spouse[0].lifeExpectancy
    }

    // console.log(this.ssAmount);
    
    this.globalService.createReport(Report, ReportMMT)
      .subscribe(
      resp => {
        // console.log('saved report data');
        this.snackBarService.add("Please wait while your medicare means testing report is being generated.", 0);
        // this.router.navigate(['/reports/create']);
        //this.router.navigateByUrl('/reports/create?d=t');
        // console.log(resp);
        this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
      },
      error => this.error = <any>error);
  }

  downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {
    this.loadingService.isLoading(true);
    var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer") };


    this.globalService.generateReport(ReportFields, this.client.client, ReportFields)
      .subscribe(
      resp => {
        // console.log('downloading report');
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error
        this.loadingService.isLoading(false);
      });
  }

  handleEditClientModal(e) {
    this.modalService.add('add-edit-client', { ID: this.client.client.ID });
  }

  handleProjectionModal(e) {
    var projectedYears = this.mmtData.IllustrationEntries.map(entry => {

      if (!this.mmtData.IncludePartner && entry.ClientAge >= this.mmtData.Client.RetirementAge) {
        return entry;
      } else if (this.mmtData.IncludePartner) {
        if (entry.ClientAge >= this.mmtData.Client.RetirementAge) {
          entry.PartnerAge = entry.PartnerAge >= this.mmtData.Partner.RetirementAge ? entry.PartnerAge : "-";
          return entry;
        } else if (entry.PartnerAge >= this.mmtData.Partner.RetirementAge) {
          entry.ClientAge = entry.ClientAge >= this.mmtData.Client.RetirementAge ? entry.ClientAge : "-";
          return entry;
        }
      }




      else if (!entry.PartnerAge && entry.ClientAge >= this.mmtData.Client.RetirementAge) {
        entry.PartnerAge = "-";
        return entry;
      } else if (!entry.ClientAge && entry.PartnerAge >= this.mmtData.Partner.RetirementAge) {
        entry.ClientAge = "-";
        return entry;
      }




      // if (entry.PartnerAge > 0 && entry.ClientAge >= this.mmtData.Client.RetirementAge) {
      //   return entry;
      // } else {

      // }
    });

    projectedYears = projectedYears.filter(Boolean);
    this.modalService.add('mmt-projections', { Data: projectedYears });
  }

  getBracketColor(bracketIndex, isSurcharge) {
    var color = '';

    if (bracketIndex === 1) {
      color = isSurcharge ? '#afb5d3' : '#afb5d3';
    } else if (bracketIndex === 2) {
      color = isSurcharge ? '#D3DFF2' : '#777';
    } else if (bracketIndex === 3) {
      color = isSurcharge ? '#F6CC9E' : '#777';
    } else if (bracketIndex === 4) {
      color = isSurcharge ? '#F7E5CD' : '#777';
    } else if (bracketIndex === 5) {
      color = isSurcharge ? '#c7b9ca ' : '#777';
    } else if (bracketIndex === 6) {
      color = isSurcharge ? '#f99a9a' : '#777';
    }

    return color;
  }

  //ZSS: this is where i need to be to change the IRMAA MMT
  //Couldnt make the graph the business wanted. If needs too, use this link for a merged graph: https://stackblitz.com/edit/ngx-charts-combo-chart
  createAreaChartData(data: any) {
    var brackets = [];
    this.areaChartData = [];

    var previousIncomeBracket = 0;

    //console.log(data);
    //console.log('json data:', JSON.stringify(data));

    
    for (var i = 0; i < data.IllustrationEntries.length; i++) {
      if (data.IllustrationEntries[i].MagiAdjustedIncomeBracket != previousIncomeBracket) {
        this.areaChartData.push({
           name: `Premium`,
           color: this.getBracketColor(data.IllustrationEntries[i].MagiAdjustedIncomeBracket, false),
           series: []
         });

        this.areaChartData.push({
          name: `Bracket ${data.IllustrationEntries[i].MagiAdjustedIncomeBracket} Surcharge`,
          color: this.getBracketColor(data.IllustrationEntries[i].MagiAdjustedIncomeBracket, true),
          series: []
        });
      }

      if (this.areaChartData[this.areaChartData.length - 2] && data.IllustrationEntries[i].HouseholdExpenseByBracket[0] > 0) {
          this.areaChartData[this.areaChartData.length - 2].series.push(
            {
              name: data.IllustrationEntries[i].Year.toString(),
              value: data.IllustrationEntries[i].HouseholdExpenseByBracket[0]
            }
          );
        //}
      }

      if (data.IllustrationEntries[i].HouseholdExpenseByBracket[data.IllustrationEntries[i].MagiAdjustedIncomeBracket - 1] - data.IllustrationEntries[i].HouseholdExpenseByBracket[0] > 0) { // if it's the first bracket -- there are no surcharges
        //if(data.IllustrationEntries[i].HouseholdExpenseByBracket[0] > 0){  
          this.areaChartData[this.areaChartData.length - 1].series.push(
              {
                name: data.IllustrationEntries[i].Year.toString(),
                value: data.IllustrationEntries[i].HouseholdExpenseByBracket[data.IllustrationEntries[i].MagiAdjustedIncomeBracket - 1] - data.IllustrationEntries[i].HouseholdExpenseByBracket[0]
              }
            );
        //}
      }

      previousIncomeBracket = data.IllustrationEntries[i].MagiAdjustedIncomeBracket;
    }

    var temp = [];

    for (var i = 0; i < this.areaChartData.length; i++) {
      if (this.areaChartData[i].series.length > 0)
        temp.push(this.areaChartData[i]);

        // if (this.areaChartData[i].name == 'Bracket 1 Premium')
        //   temp.push({ name: 'Test', color: '#000', series: [] });
    }

    //this.areaChartData = multi;

    // console.log(this.areaChartData);


    this.areaChartData = temp;

    var hasBrackets: any = [];
    var hasSurcharge: any = [];


    this.keyBrackets = [];

    this.colorScheme.domain = [];

    // Unique brackets
    for (var i = 0; i < this.areaChartData.length; i++) {
      if (!this.areaChartData[i].name.includes('Premium')) {
        if (!hasBrackets.includes(this.areaChartData[i].name)) {
          hasBrackets.push(this.areaChartData[i].name);
          this.colorScheme.domain.push(this.areaChartData[i].color);
          this.keyBrackets.push(this.areaChartData[i]);
        }
      } else {
        if (!hasSurcharge.includes(this.areaChartData[i].name)) {
          hasSurcharge.push(this.areaChartData[i].name);
          this.colorScheme.domain.push(this.areaChartData[i].color);
        }
      }
    };

//     this.colorScheme.domain = [ '#777', 'green', 'blue', 'yellow', '', ''];
    

    // hasBrackets = [];

    // for (var i = 0; i < this.areaChartData.length; i++) {
    //   if ( hasBrackets.includes(this.areaChartData) ) {
    //     this.colorScheme.domain.push(this.areaChartData[i].color);
    //     hasBrackets.push(this.areaChartData[i].name);
    //   }
      
      // if (this.areaChartData[i].name.includes('Bracket 1')) {
      //   this.colorScheme.domain.push('#FFF');  
      // }
    // }

    // console.log(this.colorScheme);

    // console.log(this.keyBrackets);

    Object.assign(this, { val: this.areaChartData });
    this.chartDataLoaded = true;
  }

  public keyBrackets: any;


  formatBracket(bracket: Number) {
    var affix = '';
    if (bracket === 1) {
      affix = '1st Bracket (No Surcharge)';
    } else if (bracket === 2) {
      affix = '2nd Bracket (67% Surcharge)';
    } else if (bracket === 3) {
      affix = '3rd Bracket (93% Surcharge)';
    } else if (bracket === 4) {
      affix = '4th Bracket (149% Surcharge)';
    } else if (bracket === 5) {
      affix = '5th Bracket (204% Surcharge)';
    }
    return affix;
  }

  setBracketData() {
    return [
      { bracket: '1st', b: 1, individual: '< $85,000', couples: '< $170,000', changeInCost: '0%' },
      { bracket: '2nd', b: 2, individual: '$85,000 - $107,000', couples: '$170,001 - $214,000', changeInCost: '37%' },
      { bracket: '3rd', b: 3, individual: '$107,001 - $133,500', couples: '$214,001 - $267,000', changeInCost: '93%' },
      { bracket: '4th', b: 4, individual: '$133,501 - $160,000', couples: '$267,001 - $320,000', changeInCost: '149%' },
      { bracket: '5th', b: 5, individual: '$160,000+', couples: '$320,000+', changeInCost: '204%' }
    ];
  }

  ssStartAgeChange(age: any) {
    this.ssStartAgeVal = age.target.value;
    this.inputFocusOut(age.target);
  }

  ssMonthlyBenefitChange(amount: any) {
    this.ssMonthlyBenefit = amount.target.value;
    this.inputFocusOut(amount.target);
  }

  ssSpouseMonthlyBenefitChange(amount: any) {
    this.ssSpouseMonthlyBenefit = amount.target.value;
    this.inputFocusOut(amount.target);
  }

  ssSpouseStartAgeChange(age: any) {
    // this.ssSpouseAgeChange = age.target.value;
    this.ssSpouseStartAgeVal = age.target.value;
    this.inputFocusOut(age.target);
  }

  inflationRateChange(percent: any) {
    this.inflationRateVal = percent.target.value;
    this.inputFocusOut(percent.target);
  }

  magiChange(amount: any) {
    this.magiVal = amount.target.value;
    this.inputFocusOut(amount.target);
  }

  includePartner(checked: any) {
    this.inputFocusOut(checked.target);
  }

  public previousFormObject: any;

  validateForm(formObject: any) {
    var formChanged = false;
    this.previousFormObject = formObject;

    for (var k in formObject) {
      // console.log(formObject[k]);
      // console.log(this.previousFormObject[k]);
      if (formObject[k] !== this.previousFormObject[k]) {
        // console.log('true');
        formChanged = true;
      }
    }

    return formChanged;
  }

  private typingTimer;
  private doneTypingInterval = 2000;
  private typerWaiting = false;

  inputFocusOut(el) {

    // console.log(this.ssStartAgeVal)
    // console.log(this.ssMonthlyBenefit)
    // console.log(this.ssSpouseMonthlyBenefit)
    //console.log(this.ssSpouseAgeChange)
    // console.log(this.inflationRateVal)
    // console.log(this.magiVal)

    clearTimeout(this.typingTimer);
    if (el.value) {
      this.typingTimer = setTimeout(() => {

        var mmtSpecificInputs = {
          InflationRate: parseFloat((this.inflationRateVal / 100).toString()),
          MagiIncomePercent: this.magiVal,
          IncludePartner: this.partnerActive,
          SocialSecurityRetirementAge: this.ssStartAgeVal,
          SSMonthlyBenefit: this.ssMonthlyBenefit,
          // LifeExpectancy: this.client.clientProfile.lifeExpectancy,
          PartnerSocialSecurityAge: this.ssSpouseStartAgeVal,
          PartnerSSMonthlyBenefit: this.ssSpouseMonthlyBenefit,
          // PartnerLifeExpectancy: this.client.clientProfile.Spouse[0].lifeExpectancy
        }

        // console.log(mmtSpecificInputs);
        // if (!this.previousFormObject)
        //   this.previousFormObject = mmtSpecificInputs;

        // if (this.validateForm(mmtSpecificInputs)) {

        this.getMMTData(this.client, mmtSpecificInputs);
        // }

      }, this.doneTypingInterval);
    }
  }



  // TODO: Make utility file
  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

}


